import { put, takeLatest } from 'redux-saga/effects';
import api, { api2, exceptionApi } from '../../../../utils/apiConfig';

import store from '../store/reducer';

import FleetLoadConfirmationActionTypes from './types';
import {
  fetchFleetLoadConfirmationDetailSuccess,
  fetchFleetLoadConfirmationDetailfailure,
  initiateFleetLoadConfirmationSuccess,
  initiateFleetLoadConfirmationFailure,
  initiatePaymentStatusSuccess,
  initiatePaymentStatusFailure,
  getTokenDetailsSuccess,
  getTokenDetailsFailure,
  getWalletBalanceSuccess,
  getWalletBalanceFailure,
  confirmDemandSuccess,
  confirmDemandFailure,
  getAppConfigSuccess,
  getAppConfigFailure,
  payTokenAmountSuccess,
  payTokenAmountFailure,
  payTokenAmountStart,
  getVehicleNumberDetailStart,
  getVehicleNumberDetailSuccess,
  getVehicleNumberDetailFailure,
  getVehicleKycDetailSuccess,
  getVehicleKycDetailFailure,
  fetchContactInfoSuccess,
  fetchContactInfoFailure,
} from './actions';
import UrlConfig from './urls';
import { showSnackBar } from '../../../../components/UI/HOC/SnackBar/store/actions';
import { showLoader } from '../../../../components/Loader/action';
import * as Sentry from '@sentry/react';

function* getFleetLoadConfirmationDetailsSaga(action: any) {
  const requestURL: any = UrlConfig.getPaymentdetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchFleetLoadConfirmationDetailSuccess(response));
  } catch (e) {
    yield put(fetchFleetLoadConfirmationDetailfailure(e));
    console.log({ e });
  }
}

function* postInitiatePaymentsSaga(action: any) {
  const requestURL = UrlConfig.initiatePayment(action.payload);
  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiateFleetLoadConfirmationFailure(response?.data?.message || 'Something went wrong'));
    } else {
      yield put(initiateFleetLoadConfirmationSuccess(response.data));
    }
  } catch (e) {
    yield put(initiateFleetLoadConfirmationFailure(e));
    console.log({ e });
  }
}

function* postInitiatePaymentStatusSaga(action: any): any {
  const requestURL = UrlConfig.initiatePaymentStatus(action.payload);
  try {
    const response = yield api.post(requestURL, action.payload.newListObj);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiatePaymentStatusFailure(response?.data?.message || 'Something went wrong'));
    } else {
      const { status, balanceInPaisa, message } = response.data;
      if (status === 'SUCCESS') {
        // demandID
        yield put(
          showSnackBar({
            variant: 'success',
            message: `Recharge successfully done`,
          }),
        );
        yield put(payTokenAmountStart({ demandId: action.payload.demandId, rechargeCallback: () => {} }));
      } else {
        yield put(
          showSnackBar({
            variant: 'error',
            message: `Recharge: ${status}`,
          }),
        );
      }
      yield put(initiatePaymentStatusSuccess(response));
    }
  } catch (e) {
    yield put(initiatePaymentStatusFailure(e));
    console.log({ e });
  }
}
function* getTokenDetails(action: any): any {
  const requestURL = UrlConfig.getTokenDetailsv2(action.payload);
  try {
    const response = yield api.get(requestURL);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      // yield put((response?.data?.message || 'Something went wrong'));
    } else {
      yield put(getTokenDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getTokenDetailsFailure(e));
    console.log({ e });
  }
}
function* getWalletBalance(action: any): any {
  const requestURL = UrlConfig.getWalletBalance();
  try {
    const response = yield api.get(requestURL);

    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      // yield put((response?.data?.message || 'Something went wrong'));
    } else {
      yield put(getWalletBalanceSuccess(response.data));
    }
  } catch (e) {
    yield put(getWalletBalanceFailure());
    console.log(e);
  }
}
function* confirmDemandStatus(action: any): any {
  const demandId = action.payload.demandId;

  const requestURL = UrlConfig.postConfirmDemand(demandId);
  const formData = {
    vehicleNumber: action.payload.vehicleNumber,
    driverNumber: action.payload.driverNumber,
    vehicleId: action.payload.vehicleId,
    driverName: action.payload.driverName,
  };
  try {
    const response = yield api.post(requestURL, formData);

    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      // yield put((response?.data?.message || 'Something went wrong'));
    } else {
      yield put(confirmDemandSuccess(response.data));
      // yield put(
      //   showLoader({
      //     msg: '',
      //     timeout: 0,
      //   }),
      // );
    }
  } catch (error) {
    const msg = error?.response?.data?.message;

    yield put(
      showSnackBar({
        variant: 'error',
        message: msg,
      }),
    );
    yield put(confirmDemandFailure(msg));
    //   // console.log('response of api', e)
    //   // yield put(confirmDemandFailure(e));
    //   // console.log({ e });
  }
}
function* payTokenAmount(action: any): any {
  const { demandId, rechargeCallback } = action.payload;
  const requestURL = UrlConfig.payTokenAmt(demandId);
  try {
    const response = yield api2.post(requestURL);
    console.log(response.data);
    if (response.data.status) {
      yield put(payTokenAmountSuccess(response.data.status));
    }
  } catch (e) {
    yield put(payTokenAmountFailure(e));
    console.log({ e });
  } finally {
    rechargeCallback();
  }
}
function* getAppConfig(action: any): any {
  const requestURL = UrlConfig.operatorWebMarketPlaceConfig();

  try {
    const response = yield api.get(requestURL);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      // yield put((response?.data?.message || 'Something went wrong'));
    } else {
      yield put(getAppConfigSuccess(response.data.data.walletRechargeSource));
    }
  } catch (e) {
    yield put(getAppConfigFailure(e));
    console.log({ e });
  }
}

function* getVehicleNumberDetail(action: any): any {
  const requestURL = UrlConfig.tokenVehicleDetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(getVehicleNumberDetailSuccess(response.data));
  } catch (e) {
    yield put(getVehicleNumberDetailFailure(e));
    console.log(e);
    Sentry.captureException(e);
  }
}

function* getVehicleKycDetailsNumberDetail(action: any): any {
  const requestURL = UrlConfig.vehicleKycDetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(getVehicleKycDetailSuccess(response.data));
  } catch (e) {
    yield put(getVehicleKycDetailFailure(e));
    console.log(e);
    Sentry.captureException(e);
  }
}
function* fetchContactInfo(action: any): any {
  const requestURL = UrlConfig.fetchContactInfo(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchContactInfoSuccess(response.data));
  } catch (e) {
    yield put(fetchContactInfoFailure(e));
    console.log(e);
    Sentry.captureException(e);
  }
}
function* fleetLoadConfirmationSaga() {
  yield takeLatest(
    FleetLoadConfirmationActionTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_START,
    getFleetLoadConfirmationDetailsSaga,
  );
  yield takeLatest(
    FleetLoadConfirmationActionTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_START,
    postInitiatePaymentsSaga,
  );
  yield takeLatest(FleetLoadConfirmationActionTypes.INITIATE_PAYMENT_STATUS_START, postInitiatePaymentStatusSaga);

  yield takeLatest(FleetLoadConfirmationActionTypes.TOKEN_DETAIL, getTokenDetails);
  yield takeLatest(FleetLoadConfirmationActionTypes.GET_BALANCE, getWalletBalance);
  yield takeLatest(FleetLoadConfirmationActionTypes.CONFIRM_DEMAND, confirmDemandStatus);
  yield takeLatest(FleetLoadConfirmationActionTypes.PAY_TOKEN, payTokenAmount);
  yield takeLatest(FleetLoadConfirmationActionTypes.MP_APP_CONFIG, getAppConfig);
  yield takeLatest(FleetLoadConfirmationActionTypes.GET_VEHICLE_NUMBER_DETAIL_START, getVehicleNumberDetail);
  yield takeLatest(FleetLoadConfirmationActionTypes.GET_VEHICLE_KYC_DETAIL_START, getVehicleKycDetailsNumberDetail);
  yield takeLatest(FleetLoadConfirmationActionTypes.FETCH_CONTACT_INFO, fetchContactInfo);
}
export default fleetLoadConfirmationSaga;
